import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ROTA } from '@/dominio/Rota';
import { makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ImgControleSessoes from '../img/controleSessoes.png';
import ReactComponent from './ReactComponent';

class MenuAcessoRapido extends ReactComponent {
    listaMenuAcessoRapido = [
        {
            title: ROTA.SESSAO.descricao,
            tooltip: ROTA.SESSAO.descricao,
            img: ImgControleSessoes,
            route: ROTA.SESSAO.rota
        }
    ];

    constructor(props) {
        super(props);

        makeObservable(this, {
            listaMenuAcessoRapido: observable
        });
    }

    render() {
        return (
            <Box style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', padding: '20px' }}>
                {this.listaMenuAcessoRapido.map((tile) => (
                    <Box
                        onClick={() => this.redirecionar(tile.route)}
                        key={this.nextKey}
                        style={{ cursor: 'pointer' }}
                    >
                        <Box>
                            <img
                                src={tile.img}
                                alt={tile.tooltip}
                                style={{ width: '50%', height: '50%' }}
                            />
                        </Box>
                        <Box>
                            <Typography className="titulo">{tile.title}</Typography>
                        </Box>
                    </Box>
                ))}
            </Box>
        );
    }
}

export default inject('stores')(observer(MenuAcessoRapido));
